export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/organizationMemberProductBusinesshour/state.js